import React from 'react';
import { Card, CardContent } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import DataTable from '../../components/ui/data-table';
import EmptyState from '../../components/ui/empty-state.jsx';
import LoadingSpinner from '../../components/common/LoadingSpinner.jsx';
import { academicService } from '../../services/academicService';
import { BookOpen } from 'lucide-react';

const SubjectsPage = () => {
  const [subjects, setSubjects] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(null);

  const fetchSubjects = async () => {
    try {
      setLoading(true);
      setError(null);
      const res = await academicService.getSubjects();
      setSubjects(res.data.data || []);
    } catch (e) {
      setError(e.response?.data?.message || 'Failed to load subjects');
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    fetchSubjects();
  }, []);

  const columns = [
    { id: 'name', header: 'Subject', accessorKey: 'name', sortable: true },
    { id: 'code', header: 'Code', accessorKey: 'code', sortable: true },
    { id: 'description', header: 'Description', accessorKey: 'description' },
  ];

  if (loading) return <LoadingSpinner />;
  if (error) return (
    <div className="p-6">
      <Card>
        <CardContent className="p-6">
          <p className="text-red-600 text-sm">{String(error)}</p>
          <Button className="mt-3" onClick={fetchSubjects}>Retry</Button>
        </CardContent>
      </Card>
    </div>
  );

  return (
    <div className="space-y-4">
      <h2 className="text-xl font-semibold">Subjects</h2>
      {(!subjects || subjects.length === 0) ? (
        <EmptyState 
          icon={BookOpen}
          title="No subjects found"
          description="Subjects will appear here when available."
          action
          actionLabel="Refresh"
          onAction={fetchSubjects}
        />
      ) : (
        <Card>
          <CardContent className="p-0">
            <DataTable data={subjects} columns={columns} searchable />
          </CardContent>
        </Card>
      )}
    </div>
  );
};

export default SubjectsPage;


